import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClick: '&'
    },
    template: `
        <div class="sidebar-toggle ico-arrow-left-to-line" ng-click="vm.onToggleClick($event)"></div>
        <style>
            learn-modal-materials-wrapper-sidebar-toggle {
                display: contents;
            }
        </style>
    `
})

export default class {
    onToggleClick ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.onClick) {
            this.onClick();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/sidebar/toggle/index.js